import ICustomForm from "../../ICustomForm";
import Text from "../Text";

export default class TextDefault extends Text implements ICustomForm
{

}